const AccountStatus = {
    // Chưa kích hoạt
	NotActive: 1,
    // Đang sử dụng
	Active: 2,
}
export default AccountStatus;